import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Nav, NavItem, Row, NavLink, TabContent, TabPane, Form, Label, Input, FormFeedback } from "reactstrap";
import Breadcrumb from "Components/Common/Breadcrumb";
import classnames from "classnames";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useParams } from 'react-router-dom';
import { useCommonDataFindAllQuery, useLakeFindAllQuery, useLakeUpdateMutation } from "store";
import MainMap from "Components/MainMap/Index";
import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';
import Measurement from "./Measurement";
import Labrator from "./Labrator";
import UsageIndex from "Components/Usage/Index";
import SafetyIndex from "Components/Safety/Index";
import OwnerIndex from "Components/Owner/Index";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const SwLakeShow = () => {

  const { id } = useParams();

  const [activeTab, setactiveTab] = useState("1");
  const [baseMap, setBaseMap] = useState("voyager")
  const tempQuery = `/${id}`;
  const { data, error, isFetching } = useLakeFindAllQuery(tempQuery);
  const [lakeMainData, setLakeMainData] = useState<any>();
  const [lakeGeom, setLakeGeom] = useState<any>();
  const [lakeGeoGeom, setLakeGeoGeom] = useState<any>();
  const [customCenter, setCustomCenter] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  const [lakeUpdate, lakeUpdateResult] = useLakeUpdateMutation();

  const {
    data: commonLake,
    error: commonLakeError,
    isFetching: isCommonLakeFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_lake_type`);

  useEffect(() => {

    setLakeMainData(data?.data)
    setLakeGeom(lakeMainData?.geom)
    setLakeGeoGeom(lakeMainData?.geom)
    const tempCenter = { cusCenter: lakeGeom?.coordinates?.[0]?.[0]?.[0] };
    setCustomCenter(tempCenter);
  }, [lakeGeom, lakeMainData, data])

  const toggle = (tab: any) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: lakeMainData?.id,
      code: lakeMainData?.code,
      name: lakeMainData?.name,
      location: lakeMainData?.location,
      geological_age_index: lakeMainData?.geological_age_index,
      sedimentary_rock_name: lakeMainData?.sedimentary_rock_name,
      cmn_lake_type: lakeMainData?.cmn_lake_type,
    },
    validationSchema: Yup.object({
      code: Yup.number().typeError("Тоон төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      name: Yup.string().typeError("Текст төрлийн утга оруулна уу !").required("Утга оруулна уу"),
      location: Yup.string().typeError("Текст төрлийн оруулна уу !").required("Утга оруулна уу"),
      geological_age_index: Yup.string().typeError("Текст төрлийн утга оруулна уу !").required("Утга оруулна уу"),
      sedimentary_rock_name: Yup.string().typeError("Текст төрлийн утга оруулна уу !").required("Утга оруулна уу"),
      cmn_lake_type: Yup.string().typeError("Утга сонгоно уу!").required("Утга оруулна уу"),
    }),
    onSubmit: (values: any) => {

      const formData = new FormData();

      // Append basic fields
      formData.append('id', lakeMainData ? lakeMainData.id.toString() : '0');
      formData.append('code', values?.code);
      formData.append('name', values?.name);
      formData.append('location', values?.location);
      formData.append('cmn_lake_type', values?.cmn_lake_type);
      formData.append('geological_age_index', values?.geological_age_index);
      formData.append('sedimentary_rock_name', values?.sedimentary_rock_name);

      if (selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file: File, index: number) => {
          formData.append(`shapes`, file);
        });
      }

      lakeUpdate(formData);
      toastr.success("Мэдээлэл амжилттай засагдлаа!", "Амжилттай");

      validation.resetForm();
      setResetFiles(true);
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Гадаргын ус" breadcrumbItem="Нуур тойром" />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>

                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "1",
                        })}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                        <span className="d-none d-sm-block">Үндсэн бүртгэл</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "2",
                        })}
                        onClick={() => {
                          toggle("2");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                        <span className="d-none d-sm-block">Хэмжилт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "3",
                        })}
                        onClick={() => {
                          toggle("3");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                        <span className="d-none d-sm-block">Шинжилгээ</span>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "4",
                        })}
                        onClick={() => {
                          toggle("4");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Ашиглалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "5",
                        })}
                        onClick={() => {
                          toggle("5");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Хамгаалалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "6",
                        })}
                        onClick={() => {
                          toggle("6");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Эзэмшигч</span>
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab} className="px-3 pt-3 text-muted">
                    <TabPane tabId="1">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Нуур, тойрмын бүртгэлийн дугаар *</Label>
                              <Input
                                name="code"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.code || ""}
                                invalid={
                                  validation.touched.code &&
                                    validation.errors.code
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.code && validation.errors.code ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.code}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">Нуур (тойром)-ын байршил *</Label>
                              <Input
                                name="location"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.location || ""}
                                invalid={
                                  validation.touched.location && validation.errors.location
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.location && validation.errors.location ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.location}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">	Нуур (тойром)-ын ёроолын хурдас чулуулгийн геологийн нас ба индекс *</Label>
                              <Input
                                name="geological_age_index"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.geological_age_index || ""}
                                invalid={
                                  validation.touched.geological_age_index && validation.errors.geological_age_index
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.geological_age_index && validation.errors.geological_age_index ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.geological_age_index}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Нуур (тойром)-ын ёроолын хурдас чулуулгийн нэр *</Label>
                              <Input
                                name="sedimentary_rock_name"
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.sedimentary_rock_name || ""}
                                invalid={
                                  validation.touched.sedimentary_rock_name && validation.errors.sedimentary_rock_name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.sedimentary_rock_name && validation.errors.sedimentary_rock_name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.sedimentary_rock_name}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Нуур (тойром)-ын нэр *</Label>
                              <Input
                                name="name"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.name || ""}
                                invalid={
                                  validation.touched.name && validation.errors.name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.name && validation.errors.name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.name}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">	Нуурын төрөл *</Label>
                              <Input
                                name="cmn_lake_type"
                                type="select"
                                className="form-select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.cmn_lake_type || ""}
                                invalid={
                                  validation.touched.cmn_lake_type &&
                                    validation.errors.cmn_lake_type
                                    ? true
                                    : false
                                }
                              >
                                <option disabled value="">Сонгох</option>
                                {commonLake?.data?.map((item, index) => (
                                  <option value={item?.id}>{item?.name}</option>
                                ))}

                              </Input>
                              {validation.touched.cmn_lake_type &&
                                validation.errors.cmn_lake_type ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.cmn_lake_type}
                                </FormFeedback>
                              ) : null}
                            </div>

                          </Col>

                          {/* <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} fileType={"multipolygon"} /> */}
                        </Row>
                        {
                          (lakeGeom) && (
                            <Row>
                              <Col lg={12}>
                                <div className='mapTypeSelection'>
                                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                                </div>
                                <MainMap baseMap={baseMap} results={lakeGeom} customCenter={customCenter} zoomChange={8} />
                              </Col>

                            </Row>
                          )}

                        <Row>
                          <Col lg={12} className="d-flex justify-content-center mt-3">
                            <button type="submit" className="btn btn-primary"> Хадгалах </button>
                          </Col>
                        </Row>
                      </Form>

                    </TabPane>
                    <TabPane tabId="2">
                      <Measurement />
                    </TabPane>
                    <TabPane tabId="3">
                      <Labrator />
                    </TabPane>
                    <TabPane tabId="4">
                      <UsageIndex id={id} table_name={'lake'} />
                    </TabPane>
                    <TabPane tabId="5">
                      <SafetyIndex id={id} table_name={'lake'} />
                    </TabPane>
                    <TabPane tabId="6">
                      <OwnerIndex id={id} table_name={'lake'} />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>


          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SwLakeShow;